import { atom } from 'jotai';

export const socketIO = atom({});
